import 'isomorphic-fetch';
import baseFetch, { createParamString } from '../baseFetch';

export const fetchLegacyChartImages = (legacyId, type, nearshoreModelName) =>
  baseFetch(`/charts/legacy/images?${createParamString({ legacyId, type, nearshoreModelName })}`);

export const fetchLegacyChartTypes = (subregionId, cookies) =>
  baseFetch(`/charts/legacy/types?${createParamString({ subregionId })}`, { cookies });
